import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

// Components
import GatsbyHead from '../../components/layout/gatsby-head';
import Layout, { Container, TwoThirds } from '../../components/layout';
import RichText from '../../components/rich-text';
import ContactCard from '../../components/contact-card';
import OpeningTimes from '../../components/opening-times';
import Assemblies from '../../components/assemblies';
import GoogleMapIframe from '../../components/google-map-iframe';
import AddressLink from '../../components/google-map-iframe/address-link';
import PageTitle from '../../components/page-title';
import withSplitTest from '../../components/with-split-test';

// Utils
import { extractLayoutProps } from '../../utils/layout';

export const Head = ({ data }) => <GatsbyHead pageContent={data.page} />;

const ServicePage = ({ data }) => {
  const { page } = data;

  const { title, service, mainBodyCopy, usefulInfoCopy, assemblies } = page;

  const times = service.openingTimes
    ? JSON.parse(service.openingTimes.internal.content)
    : null;

  return (
    <Layout {...extractLayoutProps(page, data.contentfulConfig)}>
      <article>
        <PageTitle twoThirds>
          <h1>{title}</h1>
        </PageTitle>
        <Container>
          <TwoThirds>
            <GoogleMapIframe
              placeID={service.googleMapsPlaceId}
              address={service.address}
            />
            <AddressLink
              placeID={service.googleMapsPlaceId}
              address={service.address}
            />
            <RichText richText={mainBodyCopy} />
            {service && <ContactCard {...service} />}
            {times ? <OpeningTimes data={times} /> : null}
            <RichText richText={usefulInfoCopy} />
            <Assemblies assemblies={assemblies} />
          </TwoThirds>
        </Container>
      </article>
    </Layout>
  );
};

ServicePage.propTypes = {
  data: PropTypes.shape({
    page: PropTypes.object,
    contentfulConfig: PropTypes.object,
  }),
};

export default withSplitTest(ServicePage);

export const servicePageQuery = graphql`
  query servicePageTemplateQuery($contentful_id: String!) {
    page: contentfulPageService(contentful_id: { eq: $contentful_id }) {
      ...PageServiceFragment
    }
    ...NavigationFragment
  }
`;
